import type { GridSortModel } from "@mui/x-data-grid-premium";
import type { SortConfiguration } from "../../../../../../../../api/types/svTypes.ts";
import { Ordering } from "../../../../../../../../api/types/svTypes.ts";
import { pivotSortableAggregationTypes } from "./rebuildPivotSortingFields.ts";

export const getPivotSortModel = (
  sortingFields: SortConfiguration[],
  valueFieldIds: string[],
  gridColumnIds: string[]
): GridSortModel => {
  const aggregationSort = sortingFields.find((sort) => pivotSortableAggregationTypes.includes(sort.type));
  if (
    !aggregationSort?.pivotColumnId ||
    !valueFieldIds.includes(aggregationSort.id) ||
    !gridColumnIds.includes(aggregationSort.pivotColumnId)
  ) {
    return [];
  }

  return [
    {
      field: aggregationSort.pivotColumnId,
      sort: aggregationSort.ordering === Ordering.Descending ? "desc" : "asc",
    },
  ];
};
